import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'
import { type AttributeManagementCategoryEnum } from '../types/attributeManagement.types'

const URL_ADMIN_CATALOG_ADMIN = `${URL_APP_ADMIN}/catalog-admin`

// Price Anomaly Investigation Routes
const URL_ADMIN_CATALOG_ADMIN_PRICE_ANOMALY_TAKEDOWN = `${URL_ADMIN_CATALOG_ADMIN}/price-anomaly-takedown`
const URL_ADMIN_CATALOG_ADMIN_PRICE_ANOMALY_INVESTIGATION_DETAIL = `${URL_ADMIN_CATALOG_ADMIN}/price-anomaly-investigation-detail/:investigationId`

// Quality Audit Routes
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_LIST = `${URL_ADMIN_CATALOG_ADMIN}/quality-audit-workflow-list`
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_BATCH_LIST = `${URL_ADMIN_CATALOG_ADMIN}/quality-audit-workflow-batch-list`
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_TASK_LIST = `${URL_ADMIN_CATALOG_ADMIN}/quality-audit-workflows-task-list`
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_TASK_LIST_INPUT_DATA = `${URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_TASK_LIST}/input-data/:taskUuid`
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_SUBMIT_TASKS = `${URL_ADMIN_CATALOG_ADMIN}/quality-audit-submit-tasks`
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_CREATE_WORKFLOWS = `${URL_ADMIN_CATALOG_ADMIN}/quality-audit-create-workflows`
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_METRICS = `${URL_ADMIN_CATALOG_ADMIN}/quality-audit-metrics`

// Image Management Routes
const URL_ADMIN_CATALOG_ADMIN_IMAGE_MANAGEMENT = `${URL_ADMIN_CATALOG_ADMIN}/image-management`

// Image Uploads Routes
const URL_ADMIN_CATALOG_ADMIN_CATALOG = `${URL_RETAILER_SCOPED}/catalog-tools`
const URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS = `${URL_ADMIN_CATALOG_ADMIN_CATALOG}/image-uploads`
const URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS_UPLOAD = `${URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS}/upload`
const URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS_BATCH_DETAILS = `${URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS}/:batchId`

// Product Edit Routes
const URL_ADMIN_CATALOG_ADMIN_PRODUCT_EDIT_SHOW = `${URL_ADMIN_CATALOG_ADMIN}/product-edit-show`

const URL_ADMIN_CATALOG_ADMIN_MD_PLATFORM = `${URL_ADMIN_CATALOG_ADMIN}/md-platform`
const URL_ADMIN_CATALOG_ADMIN_MD_PLATFORM_CREATE = `${URL_ADMIN_CATALOG_ADMIN}/md-platform-create`
const URL_ADMIN_CATALOG_ADMIN_MD_PLATFORM_DETAILS = `${URL_ADMIN_CATALOG_ADMIN}/md-platform-details`
const URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT = `${URL_ADMIN_CATALOG_ADMIN}/attribute-management`
const URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_CREATE = `${URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT}/create`
const URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_DETAILS = `${URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT}/details`
const URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_EDIT = `${URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT}/edit`
const URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_CLONE = `${URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT}/clone`
const URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_MODIFY = `${URL_ADMIN_CATALOG_ADMIN}/quality-audit-workflow-modify`
const URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE = `${URL_ADMIN_CATALOG_ADMIN}/data-bridge`
const URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE_CREATE = `${URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE}/create`
const URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE_EDIT = `${URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE}/edit/:bridgeName`
const URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE_BATCH_LIST = `${URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE}/batches/:bridgeName`

// MAPLE Job Dashboard Routes
const URL_ADMIN_CATALOG_ADMIN_MAPLE_JOB_DASHBOARD = `${URL_ADMIN_CATALOG_ADMIN}/maple-job-dashboard`
const URL_ADMIN_CATALOG_ADMIN_MAPLE_JOB_DETAILS = `${URL_ADMIN_CATALOG_ADMIN_MAPLE_JOB_DASHBOARD}/details`
// @hygen:inject admin-urls
export type DashRouteSet =
  | DashRouteType<'app-admin-catalog-admin'>
  | DashRouteType<'app-admin-catalog-admin-image-management'>
  | DashRouteType<'app-admin-catalog-admin-catalog'>
  | DashRouteType<'app-admin-catalog-admin-image-uploads'>
  | DashRouteType<'app-admin-catalog-admin-image-uploads-upload'>
  | DashRouteType<'app-admin-catalog-admin-image-uploads-batch-details', { batchId: string }>
  | DashRouteType<'app-admin-catalog-admin-quality-audit-workflow-list'>
  | DashRouteType<'app-admin-catalog-admin-quality-audit-workflow-batch-list'>
  | DashRouteType<'app-admin-catalog-admin-quality-audit-workflow-task-list', { batchUuid: string }>
  | DashRouteType<'app-admin-catalog-admin-product-edit-show', { productId: string }>
  | DashRouteType<
      'app-admin-catalog-admin-quality-audit-workflow-task-list-input-data',
      { taskUuid: string }
    >
  | DashRouteType<'app-admin-catalog-admin-md-platform'>
  | DashRouteType<'app-admin-catalog-admin-md-platform-create'>
  | DashRouteType<'app-admin-catalog-admin-md-platform-details', { detectionId: string }>
  | DashRouteType<'app-admin-catalog-admin-quality-audit-submit-tasks'>
  | DashRouteType<'app-admin-catalog-admin-attribute-management'>
  | DashRouteType<
      'app-admin-catalog-admin-attribute-management-create',
      { category: AttributeManagementCategoryEnum }
    >
  | DashRouteType<'app-admin-catalog-admin-attribute-management-details', { stepId: string }>
  | DashRouteType<'app-admin-catalog-admin-attribute-management-edit', { stepId: string }>
  | DashRouteType<'app-admin-catalog-admin-attribute-management-clone', { stepId: string }>
  | DashRouteType<'app-admin-catalog-admin-quality-audit-workflow-modify'>
  | DashRouteType<'app-admin-catalog-admin-quality-audit-create-workflows'>
  | DashRouteType<'app-admin-catalog-admin-quality-audit-metrics'>
  | DashRouteType<'app-admin-catalog-admin-price-anomaly-takedown'>
  | DashRouteType<
      'app-admin-catalog-admin-price-anomaly-investigation-detail',
      { investigationId: string }
    >
  | DashRouteType<'app-admin-catalog-admin-data-bridge'>
  | DashRouteType<'app-admin-catalog-admin-data-bridge-create'>
  | DashRouteType<'app-admin-catalog-admin-data-bridge-edit', { bridgeName: string }>
  | DashRouteType<'app-admin-catalog-admin-data-bridge-batch-list', { bridgeName: string }>
  | DashRouteType<'app-admin-catalog-admin-maple-job-dashboard'>
  | DashRouteType<'app-admin-catalog-admin-maple-job-details', { jobId: string }>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-catalog-admin': URL_ADMIN_CATALOG_ADMIN,
  'app-admin-catalog-admin-image-management': URL_ADMIN_CATALOG_ADMIN_IMAGE_MANAGEMENT,
  'app-admin-catalog-admin-catalog': URL_ADMIN_CATALOG_ADMIN_CATALOG,
  'app-admin-catalog-admin-image-uploads': URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS,
  'app-admin-catalog-admin-image-uploads-upload': URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS_UPLOAD,
  'app-admin-catalog-admin-image-uploads-batch-details':
    URL_ADMIN_CATALOG_ADMIN_IMAGE_UPLOADS_BATCH_DETAILS,
  'app-admin-catalog-admin-quality-audit-workflow-list':
    URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_LIST,
  'app-admin-catalog-admin-quality-audit-workflow-batch-list':
    URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_BATCH_LIST,
  'app-admin-catalog-admin-quality-audit-workflow-task-list':
    URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_TASK_LIST,
  'app-admin-catalog-admin-product-edit-show': URL_ADMIN_CATALOG_ADMIN_PRODUCT_EDIT_SHOW,
  'app-admin-catalog-admin-quality-audit-workflow-task-list-input-data':
    URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_TASK_LIST_INPUT_DATA,
  'app-admin-catalog-admin-md-platform': URL_ADMIN_CATALOG_ADMIN_MD_PLATFORM,
  'app-admin-catalog-admin-md-platform-create': URL_ADMIN_CATALOG_ADMIN_MD_PLATFORM_CREATE,
  'app-admin-catalog-admin-md-platform-details': URL_ADMIN_CATALOG_ADMIN_MD_PLATFORM_DETAILS,
  'app-admin-catalog-admin-quality-audit-submit-tasks':
    URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_SUBMIT_TASKS,
  'app-admin-catalog-admin-attribute-management': URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT,
  'app-admin-catalog-admin-attribute-management-create':
    URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_CREATE,
  'app-admin-catalog-admin-attribute-management-details':
    URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_DETAILS,
  'app-admin-catalog-admin-quality-audit-workflow-modify':
    URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_WORKFLOW_MODIFY,
  'app-admin-catalog-admin-quality-audit-create-workflows':
    URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_CREATE_WORKFLOWS,
  'app-admin-catalog-admin-quality-audit-metrics': URL_ADMIN_CATALOG_ADMIN_QUALITY_AUDIT_METRICS,
  'app-admin-catalog-admin-attribute-management-edit':
    URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_EDIT,
  'app-admin-catalog-admin-attribute-management-clone':
    URL_ADMIN_CATALOG_ADMIN_ATTRIBUTE_MANAGEMENT_CLONE,
  'app-admin-catalog-admin-price-anomaly-takedown': URL_ADMIN_CATALOG_ADMIN_PRICE_ANOMALY_TAKEDOWN,
  'app-admin-catalog-admin-price-anomaly-investigation-detail':
    URL_ADMIN_CATALOG_ADMIN_PRICE_ANOMALY_INVESTIGATION_DETAIL,
  'app-admin-catalog-admin-data-bridge': URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE,
  'app-admin-catalog-admin-data-bridge-create': URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE_CREATE,
  'app-admin-catalog-admin-data-bridge-edit': URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE_EDIT,
  'app-admin-catalog-admin-data-bridge-batch-list': URL_ADMIN_CATALOG_ADMIN_DATA_BRIDGE_BATCH_LIST,
  'app-admin-catalog-admin-maple-job-dashboard': URL_ADMIN_CATALOG_ADMIN_MAPLE_JOB_DASHBOARD,
  'app-admin-catalog-admin-maple-job-details': URL_ADMIN_CATALOG_ADMIN_MAPLE_JOB_DETAILS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
